"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContainer = exports.PrimaryActionType = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var ContentComponent_1 = require("./ContentComponent");
var TelemetryConstants = require("./telemetry/TelemetryConstants");
var TelemetryHelper_1 = require("./telemetry/TelemetryHelper");
var WarningComponent_1 = require("./WarningComponent");
var PrimaryActionType;
(function (PrimaryActionType) {
    PrimaryActionType[PrimaryActionType["CloseDialogOnly"] = 0] = "CloseDialogOnly";
    PrimaryActionType[PrimaryActionType["CloseDialogAndWorkbook"] = 1] = "CloseDialogAndWorkbook";
})(PrimaryActionType = exports.PrimaryActionType || (exports.PrimaryActionType = {}));
var DialogContainer = /** @class */ (function (_super) {
    __extends(DialogContainer, _super);
    function DialogContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { shouldShowDialog: true, shouldShowWarning: _this.shouldShowDatasourceWarning() };
        _this.closeDialog = _this.closeDialog.bind(_this);
        TelemetryHelper_1.TelemetryHelper.initSource(_this.props.source);
        TelemetryHelper_1.TelemetryHelper.addLogger(_this.props.logTelemetry);
        return _this;
    }
    DialogContainer.prototype.componentDidMount = function () {
        this.addTelemetry();
    };
    DialogContainer.prototype.componentWillUnmount = function () {
        TelemetryHelper_1.TelemetryHelper.reportAndClearTelemetry(TelemetryConstants.Closed);
    };
    DialogContainer.prototype.render = function () {
        return this.state.shouldShowDialog ? React.createElement(widgets_1.DialogWidget, __assign({}, this.createDialogProps())) : null;
    };
    DialogContainer.prototype.renderContent = function () {
        return this.state.shouldShowWarning ? (React.createElement(WarningComponent_1.WarningComponent, __assign({}, this.createWarningComponentProps()))) : (React.createElement(ContentComponent_1.ContentComponent, __assign({}, this.createContentComponentProps())));
    };
    DialogContainer.prototype.createWarningComponentProps = function () {
        var _this = this;
        return {
            handleDismissWarning: function () { return _this.setState({ shouldShowWarning: false }); },
            handlePublishDatasources: this.props.handlePublishDatasources,
        };
    };
    DialogContainer.prototype.createContentComponentProps = function () {
        var _this = this;
        return {
            isTableauOnline: this.props.isTableauOnline,
            handlePrimaryAction: function () {
                _this.handlePrimaryAction();
            },
            primaryActionButtonLabel: this.props.primaryActionButtonLabel,
            workbookInfo: this.props.workbookInfo,
        };
    };
    DialogContainer.prototype.createDialogProps = function () {
        var _this = this;
        return {
            children: this.renderContent(),
            testId: 'open-workbook-in-desktop-dialog',
            showCloseButton: !this.state.shouldShowWarning,
            type: widgets_1.DialogType.NormalWithTitleBar,
            onCloseRequest: function () {
                _this.closeDialog(TelemetryConstants.CloseButton);
                if (_this.props.onExitButtonClicked) {
                    _this.props.onExitButtonClicked();
                }
            },
            title: this.getTitle(),
            shouldRecenterOnUpdate: true,
            positioningBehavior: widgets_1.DialogPositioningBehavior.Centered,
            isModal: true,
            showFooter: false,
            dialogWidth: 500,
            disableAutoFocus: true,
        };
    };
    DialogContainer.prototype.getTitle = function () {
        return this.state.shouldShowWarning ? Localize_1.Messages.DatasourceWarningTitle() : Localize_1.Messages.DialogTitle();
    };
    DialogContainer.prototype.shouldShowDatasourceWarning = function () {
        var sizeLimit = 50 * 1024 * 1024; // 50MB
        return !!this.props.isShipPointTwo && this.props.workbookInfo.size > sizeLimit;
    };
    DialogContainer.prototype.addTelemetry = function () {
        TelemetryHelper_1.TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.IsTableauOnline, this.props.isTableauOnline);
        TelemetryHelper_1.TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.WorkbookSize, this.props.workbookInfo.size);
    };
    DialogContainer.prototype.closeDialog = function (exitType) {
        this.setState({ shouldShowDialog: false });
        TelemetryHelper_1.TelemetryHelper.reportAndClearTelemetry(exitType);
    };
    DialogContainer.prototype.handlePrimaryAction = function () {
        this.closeDialog(TelemetryConstants.PrimaryAction);
        if (this.props.handlePrimaryAction) {
            this.props.handlePrimaryAction();
        }
    };
    return DialogContainer;
}(React.PureComponent));
exports.DialogContainer = DialogContainer;
//# sourceMappingURL=DialogContainer.js.map